<template>
  <div id="app-main">
    <div class="row">
      <div class="col">
        <div class="page-title-box flex-between">
          <h4 class="page-title">平台概况</h4>
          <div class="page-title date-range">统计范围：{{ courseStatsData.time }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div :class="showData ? 'col-fix1-1367-1900 col-sm-12 col-xl-8' : 'col-sm-12 col-xl-8'">
        <div class="card-box first-row-card">
          <div class="row first-row">
            <div
              :class="
                (showData ? 'col-sm-6 col-xl-3 col-lg-3' : 'col-sm-6 col-lg-3') +
                ' flex-center-center flex-column'
              "
            >
              <div class="row">
                <div :class="(showData ? 'col-6' : 'col-12') + ' flex-center-center flex-column'">
                  <div>
                    <i class="mdi mdi-book-open-variant text-primary all-counts"></i>
                  </div>
                  <div>
                    <el-tooltip v-if="curEnv!=='gk'" class="item" effect="dark" placement="top-start">
                      <div class="tooltip-content" slot="content">
                        研究生课程：{{ courseStatsData.courses?.graduate }}门
                        <span v-if="courseStatsData.courses?.course_graduate_rate !== 0">
                          ，上线率：{{ courseStatsData.courses?.course_graduate_rate }}%
                        </span>
                        <br />
                        研究生教学班：{{ courseStatsData.courses?.class_graduate_num }}门次
                        <span v-if="courseStatsData.courses?.class_graduate_rate !== 0">
                          ，上线率：{{ courseStatsData.courses?.class_graduate_rate }}%
                        </span>
                        <br />
                        本科课程：{{ courseStatsData.courses?.undergraduate }}门
                        <span v-if="courseStatsData.courses?.course_undergraduate_rate !== 0">
                          ，上线率：{{ courseStatsData.courses?.course_undergraduate_rate }}%
                        </span>
                        <br />
                        本科教学班：{{ courseStatsData.courses?.class_undergraduate_num }}门次
                        <span v-if="courseStatsData.courses?.class_undergraduate_rate !== 0">
                          ，上线率：{{ courseStatsData.courses?.class_undergraduate_rate }}%
                        </span>
                        <br />
                        <span v-if="courseStatsData.courses?.training !== 0">
                          培训课程：{{ courseStatsData.courses?.training }}门
                          <br />
                        </span>
                        其他课程：{{ courseStatsData.courses?.other }}门
                        <br />
                      </div>
                      <div class="total-number">
                        <numberGrow
                          :value="courseStatsData.courses?.all || 0"
                          :time="5"
                        ></numberGrow>
                      </div>
                    </el-tooltip>
                    <div v-if="curEnv==='gk'" class="total-number">
                      <numberGrow
                        :value="courseStatsData.courses?.all || 0"
                        :time="5"
                      ></numberGrow>
                    </div>
                  </div>
                  <div class="text-muted">课程总数</div>
                </div>
                <div v-if="showData" class="col-6 flex-center-center flex-column">
                  <div class="detail-box" v-if="curEnv!=='gk'">
                    <div class="detail">
                      研究生课程：{{ courseStatsData.courses?.graduate }}门
                      <span v-if="courseStatsData.courses?.course_graduate_rate !== 0">
                        ，上线率：{{ courseStatsData.courses?.course_graduate_rate }}%
                      </span>
                      <br />
                      研究生教学班：{{ courseStatsData.courses?.class_graduate_num }}门次
                      <span v-if="courseStatsData.courses?.class_graduate_rate !== 0">
                        ，上线率：{{ courseStatsData.courses?.class_graduate_rate }}%
                      </span>
                      <br />
                      本科课程：{{ courseStatsData.courses?.undergraduate }}门
                      <span v-if="courseStatsData.courses?.course_undergraduate_rate !== 0">
                        ，上线率：{{ courseStatsData.courses?.course_undergraduate_rate }}%
                      </span>
                      <br />
                      本科教学班：{{ courseStatsData.courses?.class_undergraduate_num }}门次
                      <span v-if="courseStatsData.courses?.class_undergraduate_rate !== 0">
                        ，上线率：{{ courseStatsData.courses?.class_undergraduate_rate }}%
                      </span>
                      <br />
                      <span v-if="courseStatsData.courses?.training !== 0">
                        培训课程：{{ courseStatsData.courses?.training }}门
                        <br />
                      </span>
                      其他课程：{{ courseStatsData.courses?.other }}门
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              :class="
                (showData ? 'col-sm-6 col-xl-3 col-lg-3' : 'col-sm-6 col-lg-3') +
                ' flex-center-center flex-column'
              "
            >
              <div>
                <i class="mdi mdi-account-tie text-success all-counts"></i>
              </div>
              <div>
                <div class="total-number">
                  <numberGrow :value="courseStatsData.teachers || 0" :time="5"></numberGrow>
                </div>
              </div>
              <div class="text-muted">教师总数</div>
            </div>
            <div
              :class="
                (showData ? 'col-sm-6 col-xl-3 col-lg-3' : 'col-sm-6 col-lg-3') +
                ' flex-center-center flex-column'
              "
            >
              <div class="row">
                <div :class="(showData ? 'col-6' : 'col-12') + ' flex-center-center flex-column'">
                  <div>
                    <i class="mdi mdi-account-multiple text-danger all-counts"></i>
                  </div>
                  <div>
                    <el-tooltip v-if="curEnv!=='gk'" class="item" effect="dark" placement="top-start">
                      <div class="tooltip-content" slot="content">
                        本科生：{{ courseStatsData.students?.undergraduate }}人
                        <br />
                        研究生：{{ courseStatsData.students?.graduate }}人
                        <br />
                        其他学生：{{ courseStatsData.students?.other }}人
                        <br />
                      </div>
                      <div class="total-number">
                        <numberGrow
                          :value="courseStatsData.students?.all || 0"
                          :time="5"
                        ></numberGrow>
                      </div>
                    </el-tooltip>
                    <div v-if="curEnv==='gk'" class="total-number">
                      <numberGrow
                        :value="courseStatsData.courses?.all || 0"
                        :time="5"
                      ></numberGrow>
                    </div>
                  </div>
                  <div class="text-muted">学生总数</div>
                </div>
                <div v-if="showData" class="col-6 flex-center-center flex-column">
                  <div class="detail-box" v-if="curEnv !== 'gk'">
                    <div class="detail">
                      本科生：{{ courseStatsData.students?.undergraduate }}人
                      <br />
                      研究生：{{ courseStatsData.students?.graduate }}人
                      <br />
                      其他学生：{{ courseStatsData.students?.other }}人
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              :class="
                (showData ? 'col-sm-6 col-xl-3 col-lg-3' : 'col-sm-6 col-lg-3') +
                ' flex-center-center flex-column'
              "
            >
              <div class="row">
                <div :class="(showData ? 'col-6' : 'col-12') + ' flex-center-center flex-column'">
                  <div>
                    <i class="mdi mdi-map-marker text-blue all-counts"></i>
                  </div>
                  <div>
                    <el-tooltip class="item" effect="dark" placement="top-start">
                      <div class="tooltip-content" slot="content">
                        网页：{{ courseStatsData.pv?.system.web }}次
                        <br />
                        小程序：{{ courseStatsData.pv?.system.ws }}次
                        <br />
                      </div>
                      <div class="total-number">
                        <numberGrow
                          :value="courseStatsData.pv?.system.all || 0"
                          :time="5"
                        ></numberGrow>
                      </div>
                    </el-tooltip>
                  </div>
                  <div class="text-muted">访问总数</div>
                </div>
                <div v-if="showData" class="col-6 flex-center-center flex-column">
                  <div class="detail-box">
                    <div class="detail">
                      网页：{{ courseStatsData.pv?.system.web }}次
                      <br />
                      小程序：{{ courseStatsData.pv?.system.ws }}次
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="more-data-box">
              <el-button class="more" type="text" @click="showDetailData">
                {{ showData ? '收起' : '更多数据' }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div :class="showData ? 'col-fix2-1367-1900 col-sm-12 col-xl-8' : 'col-sm-12 col-xl-4'">
        <div class="card-box first-row-card real-time-box">
          <div class="row first-row">
            <div
              :class="
                (showData ? 'col-sm-6 col-md-6 col-lg-6 col-xl-6' : 'col-sm-6 col-lg-6') +
                ' real-time-nums flex-center-center flex-column'
              "
            >
              <div>
                <i class="mdi mdi-account-clock all-counts text-primary"></i>
              </div>
              <div>
                <div class="total-number">
                  <numberGrow :value="curOnlineStudent" :time="2"></numberGrow>
                </div>
              </div>
              <div>实时在线人数<span v-if="curEnv === 'gdut'">(近2小时)</span></div>
            </div>
            <div
              :class="
                (showData ? 'col-sm-6 col-md-6 col-lg-6 col-xl-6' : 'col-sm-6 col-lg-6') +
                ' real-time-courses flex-center-center flex-column'
              "
            >
              <div>
                <i class="mdi mdi-book-open-page-variant all-counts text-primary"></i>
              </div>
              <div>
                <div class="total-number">
                  <numberGrow :value="curOnlineCourse" :time="5"></numberGrow>
                </div>
              </div>
              <div>实时在线课程<span v-if="curEnv === 'gdut'">(近10分钟)</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-xl-2">
        <div class="widget-rounded-circle card-box">
          <div class="row">
            <div class="col-6">
              <div class="avatar-lg rounded-circle bg-soft-primary border-primary border">
                <i class="mdi mdi-bookmark-multiple-outline font-22 avatar-title text-primary"></i>
              </div>
            </div>
            <div class="col-6">
              <div class="text-right">
                <h3 class="mt-1">
                  <span data-plugin="counterup">
                    <numberGrow
                      :value="courseStatsData.activities?.all || 0"
                      :time="5"
                    ></numberGrow>
                  </span>
                </h3>
                <p class="text-muted mb-1 text-truncate">活动总数</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-xl-2">
        <div class="widget-rounded-circle card-box">
          <div class="row">
            <div class="col-6">
              <div class="avatar-lg rounded-circle bg-soft-success border-success border">
                <i class="mdi mdi-book-open-outline font-22 avatar-title text-success"></i>
              </div>
            </div>
            <div class="col-6">
              <div class="text-right">
                <h3 class="text-dark mt-1">
                  <span data-plugin="counterup">
                    <numberGrow :value="courseStatsData.assigns || 0" :time="5"></numberGrow>
                  </span>
                </h3>
                <p class="text-muted mb-1 text-truncate">作业总数</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-xl-2">
        <div class="widget-rounded-circle card-box">
          <div class="row">
            <div class="col-6">
              <div class="avatar-lg rounded-circle bg-soft-info border-info border">
                <i class="mdi mdi-clipboard-text-outline font-22 avatar-title text-info"></i>
              </div>
            </div>
            <div class="col-6">
              <div class="text-right">
                <h3 class="text-dark mt-1">
                  <span data-plugin="counterup">
                    <numberGrow :value="courseStatsData.quizs || 0" :time="5"></numberGrow>
                  </span>
                </h3>
                <p class="text-muted mb-1 text-truncate">测验总数</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-xl-2">
        <div class="widget-rounded-circle card-box">
          <div class="row">
            <div class="col-6">
              <div class="avatar-lg rounded-circle bg-soft-warning border-warning border">
                <i
                  class="mdi mdi-comment-text-multiple-outline font-22 avatar-title text-warning"
                ></i>
              </div>
            </div>
            <div class="col-6">
              <div class="text-right">
                <h3 class="text-dark mt-1">
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div class="tooltip-content" slot="content">
                      发帖数：{{ courseStatsData.forums?.discussions }}次
                      <br />
                      回帖数：{{ courseStatsData.forums?.posts }}次
                      <br />
                    </div>
                    <span data-plugin="counterup">
                      <numberGrow :value="courseStatsData.forums?.all || 0" :time="5"></numberGrow>
                    </span>
                  </el-tooltip>
                </h3>
                <p class="text-muted mb-1 text-truncate">讨论总数</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-xl-2">
        <div class="widget-rounded-circle card-box">
          <div class="row">
            <div class="col-6">
              <div class="avatar-lg rounded-circle bg-soft-danger border-danger border">
                <i class="mdi mdi-widgets-outline font-22 avatar-title text-danger"></i>
              </div>
            </div>
            <div class="col-6">
              <div class="text-right">
                <h3 class="text-dark mt-1">
                  <span data-plugin="counterup">
                    <numberGrow :value="courseStatsData.resources?.all || 0" :time="5"></numberGrow>
                  </span>
                </h3>
                <p class="text-muted mb-1 text-truncate">资源总数</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-xl-2">
        <div class="widget-rounded-circle card-box">
          <div class="row">
            <div class="col-6">
              <div class="avatar-lg rounded-circle bg-soft-blue border-blue border">
                <i class="mdi mdi-format-list-bulleted font-22 avatar-title text-blue"></i>
              </div>
            </div>
            <div class="col-6">
              <div class="text-right">
                <h3 class="text-dark mt-1">
                  <span data-plugin="counterup">
                    <numberGrow :value="courseStatsData.questions || 0" :time="5"></numberGrow>
                  </span>
                </h3>
                <p class="text-muted mb-1 text-truncate">试题总数</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-row>
      <el-col>
        <div class="pb-2">
          <div class="two-charts-box" v-if="termLength < 10 && termLength > 0">
            <div class="card-box">
              <div class="chart-title">课程开设量</div>
              <div id="course-charts" :style="{ height: '400px' }"></div>
            </div>
            <div class="card-box">
              <div class="chart-title">平台访问量</div>
              <div id="platform-charts" :style="{ height: '400px' }"></div>
            </div>
          </div>
          <div class="single-chart-box" v-if="termLength >= 10">
            <div class="card-box">
              <div class="chart-title">课程量与访问量</div>
              <div id="course-platform-charts" :style="{ height: '400px' }"></div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { toThousands } from '@/utils/format.js'
import NumberGrow from '@/components/NumberGrow.vue'
export default {
  components: {
    NumberGrow,
  },
  data() {
    return {
      courseChart: null,
      platFormChart: null,
      courseAndPlatFormChart: null,
      screenWidth: '',
      screenHeight: '',
      termData: [],
      courseStatsData: { online: {} },
      showData: false,
      curOnlineStudent: 0,
      curOnlineCourse: 0,
      updateTimer: null,
    }
  },
  filters: {
    filterTotalNum(val) {
      return toThousands(val)
    },
  },
  watch: {
    screenWidth() {
      this.getReSize()
    },
  },
  computed: {
    curEnv() {
      return process.env.VUE_APP_MODE
    },
    termLength() {
      return this.termData.length
    },
    courseData() {
      let x = []
      let y = []
      let data = {}
      for (let i of this.termData) {
        x.push(i.title)
        y.push(i.course)
      }
      data['x'] = x
      data['y'] = y
      return data
    },
    platformData() {
      let x = []
      let y = []
      let data = {}
      for (let i of this.termData) {
        x.push(i.title)
        y.push(i.pv)
      }
      data['x'] = x
      data['y'] = y
      return data
    },
  },
  mounted() {
    Promise.all([this.getCourseDataApi(), this.getSemesterDataApi()]).catch(err => {
      this.$message.warning(err)
    })
    if (!this.updateTimer) {
      this.updateTimer = setInterval(() => {
        this.getCourseDataApi()
      }, 60000)
    }
    this.screenWidth = document.body.clientWidth //监听页面缩放
    this.screenHeight = document.body.clientHeight
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
        this.screenHeight = document.body.clientHeight
      })()
    }
  },
  beforeDestroy() {
    if (this.updateTimer) {
      clearInterval(this.updateTimer)
    }
  },
  methods: {
    toThousands,
    // 更多数据按钮
    showDetailData() {
      this.showData = !this.showData
    },
    // 实时数据接口
    async getOnlineData() {
      await this.$store
        .dispatch('platform/getCourseData', {
          semester_id: 0,
          category_id: 0,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.curOnlineStudent = res.data.online.student
            this.curOnlineCourse = res.data.online.class
          }
        })
        .catch(err => {
          return Promise.reject(err)
        })
    },
    // 课程数据接口
    async getCourseDataApi() {
      let test = await this.$store
        .dispatch('platform/getCourseData', {
          semester_id: 0,
          category_id: 0,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.courseStatsData = res.data
            this.curOnlineStudent = this.courseStatsData.online.student
            this.curOnlineCourse = this.courseStatsData.online.class
            console.log('courseStatsData', this.courseStatsData)
          }
        })
        .catch(err => {
          return Promise.reject(err)
        })
      return test
    },
    // 学期数据接口
    async getSemesterDataApi() {
      await this.$store
        .dispatch('platform/getSemesterData')
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            if (res.data.length) {
              this.termData = res.data
              console.log('termData', this.termData)
              if (this.termLength < 10 && this.termLength > 0) {
                this.$nextTick(function () {
                  this.iniCourseChart(this.courseData)
                  this.iniPlatformChart(this.platformData)
                })
              } else if (this.termLength >= 10) {
                this.$nextTick(function () {
                  this.iniMixChart()
                })
              }
            } else {
              this.termData = []
            }
          }
        })
        .catch(err => {
          return Promise.reject(err)
        })
    },
    iniCourseChart(data) {
      var chart = this.$echarts.init(document.getElementById('course-charts'))
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: data.x,
          axisLabel: {
            interval: 0,
          },
        },
        yAxis: {
          type: 'value',
          name: '课程数',
          minInterval: 1,
          nameTextStyle: {
            color: '#98a6ad',
            padding: [0, 50, 30, 0],
            fontSize: '12',
            align: 'center',
          },
        },
        series: [
          {
            data: data.y,
            type: 'bar',
            itemStyle: {
              color: '#3283F6',
            },
          },
        ],
      }
      chart.setOption(option)
      this.courseChart = chart
    },
    iniPlatformChart(data) {
      var chart = this.$echarts.init(document.getElementById('platform-charts'))
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: data.x,
          axisLabel: {
            interval: 0,
          },
        },
        yAxis: {
          type: 'value',
          name: '人数',
          minInterval: 1,
          nameTextStyle: {
            color: '#98a6ad',
            padding: [0, 30, 30, 0],
            fontSize: '12',
            align: 'center',
          },
        },
        series: [
          {
            data: data.y,
            type: 'bar',
            itemStyle: {
              color: '#44CF9C',
            },
          },
        ],
      }
      chart.setOption(option)
      this.platFormChart = chart
    },
    iniMixChart() {
      var chart = this.$echarts.init(document.getElementById('course-platform-charts'))
      var option = {
        grid: {
          left: 60,
          right: 60,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          data: ['课程总数', '访问量'],
        },
        xAxis: [
          {
            type: 'category',
            data: this.courseData.x,
            axisLabel: {
              interval: 0,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '课程数',
            minInterval: 1,
            nameTextStyle: {
              color: '#98a6ad',
              padding: [0, 50, 30, 0],
              fontSize: '12',
              align: 'center',
            },
          },
          {
            type: 'value',
            name: '人数',
            nameTextStyle: {
              color: '#98a6ad',
              padding: [0, 0, 30, 50],
              fontSize: '12',
              align: 'center',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '课程总数',
            type: 'bar',
            itemStyle: {
              color: '#3283F6',
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + '门'
              },
            },
            data: this.courseData.y,
          },
          {
            name: '访问量',
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              color: '#F86262',
            },
            // tooltip: {
            //   valueFormatter: function (value) {
            //     return value + '次'
            //   },
            // },
            data: this.platformData.y,
          },
        ],
      }
      chart.setOption(option)
      this.courseAndPlatFormChart = chart
    },
    getReSize() {
      let chartArr = [this.courseChart, this.platFormChart, this.courseAndPlatFormChart]
      for (let i = 0; i < chartArr.length; i++) {
        //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
        setTimeout(function () {
          if (chartArr[i]) {
            chartArr[i].resize()
          }
        }, 200)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.all-counts {
  font-size: 26px;
}
.el-tooltip.item {
  cursor: pointer;
}
.tooltip-content {
  font-size: 14px;
  line-height: 21px;
}
.total-number {
  font-size: 28px;
  font-weight: bold;
  color: #343a40;
}
.page-title-box {
  h4.page-title {
    font-weight: 600;
  }
  .date-range {
    color: rgba(108, 117, 125, 1);
    font-size: 14px;
  }
}
.first-row-card {
  padding: 36px 0;
  .first-row {
    position: relative;
    .more-data-box {
      position: absolute;
      right: 34px;
      top: -30px;
    }
    .detail-box {
      padding: 5px 10px;
      background: #f8fafc;
      border-radius: 4px;
      .detail {
        font-size: 14px;
        color: #6c757d;
        line-height: 21px;
        white-space: nowrap;
      }
    }
  }
}

.real-time-box {
  background: url('~@/assets/images/common/img_live_leftdown.png') left bottom no-repeat,
    url('~@/assets/images/common/img_live_rightup.png') right top no-repeat;
  background-origin: padding-box;
  background-color: rgba(50, 148, 246, 0.25);
}
.chart-title {
  margin-bottom: 36px;
  font-size: 16px;
  font-weight: bold;
  color: #343a40;
}
.two-charts-box {
  display: flex;
  justify-content: space-between;
  .card-box {
    width: 49.5%;
  }
}
.single-chart-box {
  .card-box {
    width: 100%;
  }
}
.real-time-nums.col-sm-6.col-md-6.col-lg-6.col-xl-6 {
  margin-top: 6px;
  margin-bottom: 6px;
}

@media (max-width: 1366px) {
  .two-charts-box {
    display: block;
    .card-box {
      width: 100%;
    }
  }
}
@media screen and (max-width: 1200px) and (min-width: 991px) {
  .first-row-card {
    .first-row {
      .col-sm-6.col-xl-3 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }
  }
}
@media screen and (max-width: 2120px) and (min-width: 1367px) {
  .col-fix1-1367-1900.col-sm-12.col-xl-8 {
    flex: 0 0 80%;
    max-width: 80%;
  }
  .col-fix2-1367-1900.col-sm-12.col-xl-8 {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .first-row-card {
    .first-row {
      .col-sm-6.col-xl-3 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }
  }
  .real-time-nums.col-sm-6.col-md-6.col-lg-6.col-xl-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .real-time-courses.col-sm-6.col-md-6.col-lg-6.col-xl-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media screen and (min-width: 1900px) {
  .col-fix1-1367-1900.col-sm-12.col-xl-8 {
    flex: 0 0 66.66666%;
    max-width: 66.66666%;
  }
  .col-fix2-1367-1900.col-sm-12.col-xl-8 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
}
</style>
